import React from 'react';

/**
 * A single labeled field. type can be 'text' | 'email' | 'password' | 'number' |
 * 'date' | 'textarea' | 'select' | 'file'. For 'select', pass `options`:
 * [{ value, label }]. Kept intentionally dumb (controlled value/onChange) so it
 * works the same whether the parent state is a single field or a whole form object.
 */
export default function FormField({ label, type = 'text', value, onChange, options, hint, error, required, multiple, ...rest }) {
  const id = rest.id || rest.name;

  const renderInput = () => {
    if (type === 'select') {
      return (
        <select id={id} value={value ?? ''} onChange={onChange} multiple={multiple} {...rest}>
          {!multiple && <option value="">Select...</option>}
          {(options || []).map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    }
    if (type === 'textarea') {
      return <textarea id={id} value={value ?? ''} onChange={onChange} {...rest} />;
    }
    if (type === 'file') {
      return <input id={id} type="file" onChange={onChange} {...rest} />;
    }
    return <input id={id} type={type} value={value ?? ''} onChange={onChange} {...rest} />;
  };

  return (
    <div className="form-field">
      <label htmlFor={id}>
        {label}
        {required ? ' *' : ''}
      </label>
      {renderInput()}
      {hint && !error && <span className="field-hint">{hint}</span>}
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}
